import React, { useState, useEffect, useRef } from "react";
import { RouteComponentProps, useHistory } from "react-router-dom";
import {
  Flex,
  Table,
  Thead,
  Tr,
  Td,
  Tbody,
  Link,
  VStack,
  Button,
  Heading,
  Text,
  useToast,
  Stack,
  useDisclosure,
  HStack,
  Checkbox,
  AlertDialogHeader,
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogFooter
} from "@chakra-ui/react";

import { Header } from "../../components/Header";
import { useUserPendingReviews, UserPendingReview } from "../../utils/reviewer";
// import { SubmitReview } from "../../components/SubmitReview/SubmitReview";
import { SubmitReview } from "../../components/SubmitReview/SubmitReviewNew";
import { AlertDialogBox2 } from "../../components/SubmitReview/AlertDialogBox2";
import { ReactComponent as Hand } from "../../assets/images/hand.svg";
import { useAuth } from "../../utils/auth-context";

export const ReviewerDashboard = (props: RouteComponentProps) => {
  const toast = useToast();
  const { reviews } = useUserPendingReviews();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data: user } = useAuth();
  const [
    selectedReview,
    setSelectedReview
  ] = useState<UserPendingReview | null>(null);
  const cancelRef = useRef<HTMLDivElement>(null);
  const [storeValue, setStoreValue] = useState<Boolean>(false);
  const [getValue, setGetValue] = useState<any>();
  let history = useHistory();
  const localStorageKey1 = "PS-Reminder";
  function handleUserResponse() {
    window.localStorage.setItem(localStorageKey1, JSON.stringify(storeValue));
    const value = window.localStorage.getItem(localStorageKey1);
    setGetValue(value);
    return storeValue;
  }

  useEffect(() => {
    const value = window.localStorage.getItem(localStorageKey1);
    setGetValue(value);
  }, []);

  const HandleChange = (e: any) => {
    const my = e.target.checked;
    setStoreValue(my);
  };

  const {
    isOpen: isAlerDialogBox2Open,
    onClose: onAlertDialogBox2Close,
    onOpen: onAlertDialogBox2Open
  } = useDisclosure();
  function onback() {
    setSelectedReview(null);
  }
  return (
    <>
      <Header {...props} />
      <Flex flexGrow={1} mx={28} flexDirection="column">
        {selectedReview ? (
          <>
            {/* <SubmitReview
              onback={onback}
              review={{
                revieweeId:
                  selectedReview.people_assessments_reviewee_idTopeople.id,
                assessmentId: selectedReview.id
              }}
              onSuccess={() => {
                setSelectedReview(null);
                toast({
                  description: "Thank you for submitting the review.",
                  status: "success",
                  duration: 9000,
                  isClosable: true
                });
              }}
            /> */}
            {/* <AlertDialogBox2
              isOpen={isAlerDialogBox2Open}
              onClose={onAlertDialogBox2Close}
             
              review={{
                revieweeId: selectedReview.reviewee_id
              }}
              // staff={staff}
            /> */}
          </>
        ) : (
          <Stack direction="column" my="10" spacing={5} bg="faintBlue">
            <HStack>
              <Heading color="#05103D" fontSize={"24px"}>
                Welcome, {user?.first_name}{" "}
              </Heading>
              {/* <Hand width="20px" height="20px" display="inline" /> */}
            </HStack>
            <Text fontSize={"13px"}>
              Below you can see the name of any people you have been asked to
              review. To begin a staff review please click on the{" "}
              <Text
                display="inline"
                color="primary"
                fontWeight="700"
                fontSize={"13px"}
              >
                'To Review'
              </Text>{" "}
              link at the end of the relevant row. You will be asked 39
              questions and the first 32 require a yes or no answer. You may
              sometimes feel a people sits somewhere between ‘yes and no’ and
              you will need to use your judgement to select the most appropriate
              answer. Once you have completed all questions, simply click to
              submit your answers. Thank you.
            </Text>

            <Table variant="simple" borderWidth={1}>
              <Thead>
                <Tr
                  fontSize={"13px"}
                  style={{ height: "40px" }}
                  pt={"2"}
                  pb={"2"}
                >
                  <Td pt={"2"} pb={"2"}>
                    First Name
                  </Td>
                  <Td pt={"2"} pb={"2"}>
                    Last Name
                  </Td>
                  <Td pt={"2"} pb={"2"}>
                    Job Title
                  </Td>
                  <Td pt={"2"} pb={"2"}>
                    Department
                  </Td>
                  <Td pt={"2"} pb={"2"}>
                    Review Status
                  </Td>
                </Tr>
              </Thead>
              <Tbody boxShadow="md" fontSize={"13px"} color="#05103D">
                {reviews?.map((review: any) => (
                  <Tr
                    background="white"
                    borderTop="2px solid lightGray"
                    key={review.id}
                  >
                    <Td pt={"3"} pb={"3"}>
                      {review.people_assessments_reviewee_idTopeople.first_name}
                    </Td>
                    <Td pt={"3"} pb={"3"}>
                      {review.people_assessments_reviewee_idTopeople.sur_name}
                    </Td>
                    <Td pt={"3"} pb={"3"}>
                      {
                        review.people_assessments_reviewee_idTopeople
                          .designation
                      }
                    </Td>
                    <Td pt={"3"} pb={"3"}>
                      {review.people_assessments_reviewee_idTopeople.dept}
                    </Td>
                    <Td fontWeight="700" pt={"3"} pb={"3"}>
                      <Link
                        color="primary"
                        onClick={() => {
                          setSelectedReview(review);
                          onOpen();
                          onAlertDialogBox2Open();
                          history.push(
                            `/review_management/Submit_Reviews?revieweeId=${review.reviewee_id}&assessmentId=${review.id}`
                          );
                        }}
                      >
                        To Review
                      </Link>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Stack>
        )}
        {getValue === "true" ? null : (
          <AlertDialog
            motionPreset="slideInBottom"
            leastDestructiveRef={cancelRef}
            onClose={onClose}
            isOpen={isOpen}
            size={"3xl"}
            isCentered
          >
            <AlertDialogOverlay />
            <AlertDialogContent>
              <AlertDialogHeader
                fontSize={"24px"}
                fontWeight={"700"}
                display={"flex"}
                color={"#05103D"}
                justifyContent={"center"}
              >
                Review People
              </AlertDialogHeader>
              <AlertDialogCloseButton
                onClick={() => {
                  onClose();
                  setSelectedReview(null);
                }}
              />
              <AlertDialogBody>
                <Text fontSize={"13px"} fontWeight={"normal"} color={"#05103D"}>
                  You will now be asked 39 questions. The first 32 require a
                  ‘Yes’ or ‘No’ answer. You may feel a people sits between ‘Yes’
                  and ‘No’ for some questions so you will need to use your
                  judgement to select the most appropriate answer. Where you
                  believe a non-teaching people does not have a direct impact on
                  an area, for example, student attainment, you should consider
                  how well they perform their role and how this supports
                  students or those teaching them. Once you have completed all
                  the questions, simply click ‘Submit’ to submit your review.
                  Thank you.
                </Text>
              </AlertDialogBody>

              <AlertDialogFooter
                display={"flex"}
                justifyContent={"center"}
                marginBottom={"18px"}
              >
                <VStack>
                  <HStack marginBottom={"18px"}>
                    <Button
                      color={"white"}
                      bgColor={"#53B5E0"}
                      width={"170px"}
                      height={"40px"}
                      borderRadius={"10px"}
                      cursor={"pointer"}
                      fontSize={"13px"}
                      mr={3}
                      _hover={{
                        background: "#95c7e3e8"
                      }}
                      onClick={() => {
                        onClose();
                        handleUserResponse();
                        // onAlertDialogBox2Open();
                      }}
                    >
                      Continue to Review
                    </Button>
                    <Button
                      color={"#05103D"}
                      bgColor={"white"}
                      border={"1px solid #05103D"}
                      width={"160px"}
                      height={"40px"}
                      fontSize={"13px"}
                      cursor={"pointer"}
                      borderRadius={"10px"}
                      onClick={() => {
                        onClose();
                        setSelectedReview(null);
                      }}
                    >
                      Cancel
                    </Button>
                  </HStack>
                  <HStack>
                    <Checkbox
                      onChange={HandleChange}
                      defaultChecked={false}
                    ></Checkbox>
                    <Link
                      color={"#6A6B6C"}
                      fontWeight={"700"}
                      fontSize={"13px"}
                      textDecoration={"underline"}
                      cursor="default"
                    >
                      Don’t Show Me Again
                    </Link>
                  </HStack>
                </VStack>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        )}
      </Flex>
    </>
  );
};
